import styles from "./SuccessfullyModal.module.scss";
import close from "../../../assets/icons/close.svg";
import Button from "../../button/Button";
import { useTranslation } from "react-i18next";

interface SuccessfullyModalProps {
  setIsModalPauseConfirmVisible: (arg: boolean) => void;
  tittle: string;
  subtitle: string;
}

const SuccessfullyModal: React.FC<SuccessfullyModalProps> = ({
  setIsModalPauseConfirmVisible,
  tittle,
  subtitle,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.root}>
      <div className={styles.root_header}>
        <p className={styles.root_header_title}>{tittle}</p>
        <div className={styles.root_header_imgBlock}>
          <img
            className={styles.root_header_img}
            src={close}
            alt="close"
            onClick={() => setIsModalPauseConfirmVisible(false)}
          />
        </div>
      </div>
      <p className={styles.root_subtitle}>{subtitle}</p>
      <div className={styles.root_button}>
        <Button
          onClick={() => setIsModalPauseConfirmVisible(false)}
          text={t("Return to Account")}
          classNames={styles.root_btn}
        />
      </div>
    </div>
  );
};

export default SuccessfullyModal;
